import React from 'react';

import s from './ErrorBoundary.module.scss';

/**
 * ErrorBoundary leggero. Wrappa un sottoalbero, intercetta le eccezioni
 * di render e mostra un fallback amichevole con CTA "Ricarica".
 *
 * Uso:
 *   <ErrorBoundary>
 *     <FeatureSubtree />
 *   </ErrorBoundary>
 *
 * Per UX dedicate passare `fallback` come elemento o funzione
 * `(error, reset) => ReactNode`.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  handleReset() {
    this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    const { children, fallback } = this.props;

    if (!error) return children;

    if (typeof fallback === 'function') return fallback(error, this.handleReset);
    if (fallback) return fallback;

    return (
      <div className={s.root} role="alert">
        <i className={`fa-solid fa-triangle-exclamation ${s.icon}`} aria-hidden="true" />
        <p className={s.title}>Qualcosa è andato storto</p>
        <p className={s.message}>{error?.message || 'Errore sconosciuto'}</p>
        <button type="button" className={s.button} onClick={this.handleReset}>
          Riprova
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
